export enum FormTypeE {
  SponsorApplication = 'SponsorApplication',
  TalentApplication = 'TalentApplication',
  TalentApplicationProfile = 'TalentApplicationProfile',
  TalentApplicationStatus = 'TalentApplicationStatus',
  TalentApplicationFinancialModels = 'TalentApplicationFinancialModels',
}
